import { FilterOption } from "@models/grid/grid-filter";

export enum AlertStatus {
  New,
  Postponed,
  Archived,
  Ignored
}

export enum ResolvedStatus {
  NotResolved,
  Resolved,
  ResolvedManually,
  None,
  NotActual
}

export enum AlertSeverity {
  Low,
  Moderate,
  Critical
}

export enum AlertType {
  DebtReports,
  ValidationReport,
  AsicInvoice,
  ChangeOfNameCertificate,
  CompanyStatement,
  AsicDataIssue,
  IdentifiedExternalChanges,
  XpmSyncIssue,
  AsicShareIssue,
  AsicConnectionIssue,
  FailedEmails,
  Others
}

export enum ActionType {
  AsicForm,
  ApiCall,
  IntegrationChange,
  Manual,
  UploadDocuments,
  AdjustSecurities,
  PrepareForm492,
  OpenDocument
}

export const AlertActionButtonIconClass: Record<ActionType, string> = {
  [ActionType.AsicForm]: "",
  [ActionType.ApiCall]: "",
  [ActionType.IntegrationChange]: "",
  [ActionType.Manual]: "ic-resolve-20",
  [ActionType.UploadDocuments]: "",
  [ActionType.AdjustSecurities]: "",
  [ActionType.PrepareForm492]: "",
  [ActionType.OpenDocument]: "ic-documents-20",
} as Record<ActionType, string>;

export const alertStatusLabels: Record<AlertStatus, string> = {
  [AlertStatus.New]: 'New / Read',
  [AlertStatus.Postponed]: 'Postponed',
  [AlertStatus.Archived]: 'Archived',
  [AlertStatus.Ignored]: 'Ignored',
};

export const alertTypeLabelsPlural: Record<AlertType, string> = {
  [AlertType.DebtReports]: 'Debt Reports',
  [AlertType.ValidationReport]: 'Validation Reports',
  [AlertType.AsicInvoice]: 'ASIC Invoices',
  [AlertType.ChangeOfNameCertificate]: 'Change Of Name Certificates',
  [AlertType.CompanyStatement]: 'Company Statements',
  [AlertType.AsicDataIssue]: 'ASIC Data Issues',
  [AlertType.IdentifiedExternalChanges]: 'Identified External Changes',
  [AlertType.XpmSyncIssue]: 'XPM Sync Issues',
  [AlertType.AsicShareIssue]: 'ASIC Share Issues',
  [AlertType.AsicConnectionIssue]: 'ASIC Connection Issues',
  [AlertType.FailedEmails]: 'Failed Emails',
  [AlertType.Others]: 'Other',
};

export const alertTypesFilterOptions: FilterOption[] = Object.entries(alertTypeLabelsPlural)
  .filter(([alertType]) => {
    // Remove 'Others' and 'Failed Emails' types
    return +alertType != AlertType.Others
      && +alertType != AlertType.FailedEmails;
  })
  .sort(([_, labelA], [__, labelB]) => labelA.localeCompare(labelB))
  .map(([alertType, label]) => {

    return {
      label,
      value: alertType,
      active: false
    };
  });

export const alertStateFilterOptions: FilterOption[] = [
  AlertStatus.New,
  AlertStatus.Archived,
  AlertStatus.Ignored,
  AlertStatus.Postponed,
].map((alertStatus) => {
  return {
    label: alertStatusLabels[alertStatus],
    value: alertStatus.toString(),
    active: false
  };
});
